import React, { useState, useContext } from "react";
import Modal from "common/Modal.jsx";
import ActionsContext from "common/ActionsContext";
import styled from "styled-components";

const Wrapper = styled.div`
  text-align: left;
`;

const ErrorModal = ({ error, setError }) => {
  const actions = useContext(ActionsContext);
  return (
    <Modal
      title="Something went wrong"
      onClose={() => setError(null)}
      content={() => <Wrapper>{String(error)}</Wrapper>}
    />
  );
};

export default ErrorModal;
